import React from "react";
import {
    DataGrid,
    HeaderFilter,
    FilterRow,
    Editing,
    Column,
    Paging,
    Pager,
    Lookup,
    Format,
    FormItem,
    Sorting,
} from "devextreme-react/data-grid";
import uiInfo from "../ui-info";
import PaginaToolbar from "../components/PaginaToolbar";
import { criarAliquotaIPTUDs, opcoesFatoresDs } from "../DataSources";
import UserInfo from "../UserInfo";

export default class AliquotasIPTUBox extends React.Component {
    constructor() {
        super();
        this.initNewRow = this.initNewRow.bind(this);
        this.naturezasDataSource = [
            { id: "T", descricao: "Territorial" },
            { id: "E", descricao: "Edificado" }
        ];
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="ALÍQUOTAS IPTU">
                    <DataGrid
                        dataSource={criarAliquotaIPTUDs()}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        wordWrapEnabled={true}
                        columnAutoWidth={true}
                        focusedRowEnabled={true}
                        onInitNewRow={this.initNewRow}>
                        <HeaderFilter visible={true} />
                        <FilterRow visible={true} />
                        <Editing mode={"popup"} allowAdding={false} allowUpdating={true} allowDeleting={true} />
                        <Column dataField={"id"} visible={false}>
                            <FormItem visible={false}></FormItem>
                        </Column>
                        <Column dataField={'descricao'} caption={"Descrição"} />
                        <Column dataField={'valor'} caption={"Valor"}>
                            <Format type={"fixedPoint"} precision={2} />
                        </Column>

                        <Column dataField={'ano'} caption={"Ano"} visible={true}>
                            <Format type={"fixedPoint"} visible={true} />
                        </Column>
                        <Column dataField={'prioridade'} caption={"Prioridade"} visible={true}>
                            <Format type={"fixedPoint"} visible={true} />
                        </Column>
                        <Column dataField={'qtdeMinInfra'} caption={"Qtde. Mínima Infra"} visible={true}>
                            <Format type={"fixedPoint"} visible={true} />
                        </Column>
                        <Column dataField={'opcaoScore1Id'} caption={"Opç. Score"}>
                            <Lookup
                                dataSource={opcoesFatoresDs()}
                                valueExpr={"id"}
                                displayExpr={"opcaoDisplay"}
                            />
                        </Column>
                        <Column
                            dataField={'opcaoScore2Id'}
                            caption={"Opç. Score 2"}>
                            <Lookup
                                dataSource={opcoesFatoresDs()}
                                valueExpr={"id"}
                                displayExpr={"opcaoDisplay"} />
                        </Column>
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    initNewRow(e) {
        e.data.prefeituraId = UserInfo.getPrefeitura();
    }
}